import {
  Box,
  Button,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { SiteServiceForm } from "../Fields";
import { createYupSchema } from "../../../utilities/yupSchemaCreator";
import { useSite } from "../../Sites/Provider";
import { useService } from "../../Services/Provider";
import { useMember } from "../provider";

const yupSchema = SiteServiceForm.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const AddServiceToMember = ({ member, handleClose, existRow }) => {
  const theme = useTheme();

  const [MultiSitesChosen, setMultiSitesChosen] = useState([]);
  const [siteId, setSiteId] = useState();
  const {
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: member,
  });

  const {
    state: { Names: sites },
    fetchSiteNames: fetchSites,
  } = useSite();
  const {
    state: { serviceNames },
    fetchServiceNames,
  } = useService();
  useEffect(() => {
    if (siteId) fetchServiceNames(siteId,true);
  }, [siteId]);

  useEffect(() => {
    fetchSites(member?.company?.id);
  }, [member, fetchSites]);

  const getData = (name) => {
    switch (name) {
      case "siteIds":
        return sites?.filter(
          (s) => !member?.services?.flatMap((site) => site.id).includes(s.id)
        );
      case "services":
        return !existRow
          ? serviceNames
          : serviceNames?.filter((service) => {
              const serviceArray = existRow?.services?.servises ?? [];
              const existingServiceIds = serviceArray.flatMap(
                (ss) => ss?.id ?? []
              );
              return !existingServiceIds.includes(service.id);
            });
      default:
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    const selectedIds = Array.isArray(value)
      ? value.map((item) => (typeof item === "object" ? item.id : item))
      : [];
    setMultiSitesChosen(typeof value === "string" ? value.split(",") : value);
    setValue("serviceIds", selectedIds);
  };

  const { fetchOne: fetchMember, edit } = useMember();

  const onSubmit = async (values) => {
    try {
      await edit(values, member?.id);
      handleClose();
      fetchMember(member?.id);
    } catch (error) {
      console.log(error, "error");
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Typography
        id="modal-modal-description"
        sx={{ textAlign: "center", fontWeight: 600, mb: 2 }}
      >
        Add New Site with Service to this member
      </Typography>

      {SiteServiceForm.map((f, index) => {
        return (
          <div style={{ textAlign: "center" }}>
            {f.select && (
              <>
                {existRow ? (
                  <div>
                    <Typography variant="body2" component="h6" gutterBottom>
                      {f.label}
                    </Typography>
                    <Box
                      sx={{
                        borderBottom: "1px solid gray",
                        width: "290px",
                        borderRadius: "8px",
                        marginLeft: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      {existRow?.name}
                    </Box>
                  </div>
                ) : (
                  <FormControl
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb * 2,
                      display: f.name === "siteId" && "none",
                    }}
                    required
                    error={!!errors[f.name]}
                    key={index}
                  >
                    <InputLabel id="demo-simple-select-label">
                      {f.label}
                    </InputLabel>

                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label={f.label}
                      onChange={(e) => {
                        setSiteId(e.target.value);
                        setValue("siteIds", [e.target.value]);
                      }}
                      size="small"
                    >
                      {getData(f.name)?.map((s, index) => (
                        <MenuItem key={index} value={s.id}>
                          {s.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {getData(f.getData)?.length === 0 && (
                      <p>no sites available</p>
                    )}
                  </FormControl>
                )}
              </>
            )}
            {f.multiSelect && (
              <FormControl
                sx={{
                  width: theme.dimensions.width,
                  mt: theme.dimensions.mt,
                  mb: theme.dimensions.mb,
                }}
                size="small"
              >
                <InputLabel id="demo-simple-select-label">{f.label}</InputLabel>{" "}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  size="small"
                  multiple={f.multiSelect ? true : false}
                  value={MultiSitesChosen}
                  onChange={handleChange}
                  required={true}
                  error={!!errors[f.name]?.message}
                  input={
                    <OutlinedInput id="select-multiple-chip" label="Chip" />
                  }
                  renderValue={(selected) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      {selected.map((value) => (
                        <Chip key={value?.id} label={value.name} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {serviceNames?.map((c, i) => (
                    <MenuItem key={i} value={c}>
                      {c.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  htmlFor="demo-simple-select"
                  sx={{ color: "#d32f2f" }}
                >
                  {errors[f.name]?.message}
                </FormHelperText>
              </FormControl>
            )}
          </div>
        );
      })}
      <Button
        type="submit"
        sx={{
          background: theme.color.blackBackground,
          color: "white",
          width: "100%",
          mb: 1.3,
          "&:hover": { background: `${theme.color.black}` },
        }}
      >
        save{" "}
      </Button>
      <Button
        onClick={handleClose}
        sx={{
          background: theme.color.gray200,
          color: "black",
          width: "100%",
          "&:hover": { background: `${theme.color.gray300}` },
        }}
      >
        Cancel
      </Button>
    </form>
  );
};

export default AddServiceToMember;
